/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RegistryApplicationImage
 */
export interface RegistryApplicationImage {
  /**
   *
   * @type {string}
   * @memberof RegistryApplicationImage
   */
  fileUrl: string
}

/**
 * Check if a given object implements the RegistryApplicationImage interface.
 */
export function instanceOfRegistryApplicationImage(
  value: object
): value is RegistryApplicationImage {
  if (!('fileUrl' in value) || value['fileUrl'] === undefined) return false
  return true
}

export function RegistryApplicationImageFromJSON(
  json: any
): RegistryApplicationImage {
  return RegistryApplicationImageFromJSONTyped(json, false)
}

export function RegistryApplicationImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryApplicationImage {
  if (json == null) {
    return json
  }
  return {
    fileUrl: json['fileUrl'],
  }
}

export function RegistryApplicationImageToJSON(
  value?: RegistryApplicationImage | null
): any {
  if (value == null) {
    return value
  }
  return {
    fileUrl: value['fileUrl'],
  }
}
